"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadgeWrapper = exports.BadgeText = void 0;

var _context = require("../context");

var _text = require("../text");

var _constants = require("./constants");

var BadgeWrapper = (0, _context.styledWithTheme)('span')(function (_ref) {
  var colorScheme = _ref.colorScheme,
      type = _ref.type,
      selectors = _ref.theme.selectors;
  return {
    alignItems: 'center',
    backgroundColor: selectors.color(_constants.badgeColors[type][colorScheme].backgroundColor),
    borderRadius: selectors.radius(_constants.BORDER_RADIUS),
    color: selectors.color(_constants.badgeColors[type][colorScheme].textColor),
    display: 'flex',
    height: _constants.BADGE_SIZE,
    justifyContent: 'center',
    minWidth: _constants.BADGE_SIZE,
    padding: '0 4px',
    width: 'fit-content'
  };
});
exports.BadgeWrapper = BadgeWrapper;

var BadgeText = _text.Text.withComponent('span', {
  target: "ed827cs0"
});

exports.BadgeText = BadgeText;
BadgeText.defaultProps = _text.Text.defaultProps;